import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubAboutHeVideoVideoContentId: string;
		}
	},

	slug: string
}

class Video extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub About He Video Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeVideoVideoContentId || '', 'he_hub_about_he_video', { animCls: 'animate__zoomIn50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Video;